import { signIn } from 'next-auth/react';
import { useTranslations } from 'next-intl';
import SocialButton from '../ui/SocialButton';
import fb from '/public/assets/fb.png';
import google from '/public/assets/google.png';

const MediaButton = () => {
  const t = useTranslations('media_button');
  const handleSignIn = (provider: string) => {
    signIn(provider, { callbackUrl: '/' }); // You can modify the callback URL if needed
  };
  return (
    <div className="mt-12">
      <p className="mb-6 text-base text-clr-0a dark:text-white">{t('media_button_or')}</p>
      <div className="flex flex-col gap-4">
        <SocialButton img={fb} name={t('media_button_fb')} onClick={() => handleSignIn('facebook')} />
        <SocialButton img={google} name={t('media_button_google')} onClick={() => handleSignIn('google')} />
        {/* <SocialButton img={apple} name={t('Apple')} onClick={() => handleSignIn('apple')} /> */}
      </div>
    </div>
  );
};

export default MediaButton;
